import script from "./EnterBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EnterBox.vue?vue&type=script&setup=true&lang=js"

import "./EnterBox.vue?vue&type=style&index=0&id=872090fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-872090fc"]])

export default __exports__